import { observable, action, runInAction, computed, toJS } from 'mobx';
import BasePaginationStore from '@store/Common/BasePaginationStore';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';
import { server_address } from '@src/env-config';
import {message} from "antd";
import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";
import MyAgentStore from '@store/LoginUser/MyAgentStore';

class Item {
  constructor(data) {
    this.init(data);
  }

  @action
  init(data) {
    if (data == undefined) {
      return
    }

    for(let attr in data) {
      this[attr] = data[attr];
    }
  }

  @observable
  id = "";

  @observable
  pay_time = '';

  @observable
  nick_name = "";

  @observable
  pet_name = "";

  //金额
  @observable
  money = "";

  @observable
  u_id = '';

}

class PaginationStore extends BasePaginationStore {

}

/**
 * 页面头部筛选过滤器字段值
 */
class FilterStore {

  //是否初始化过
  is_init;

  search;
  type;
  proxy_type = CustomerTypeSelect.getTypeId(CustomerTypeSelect.TYPE_AGENT_ALL);
  //代理昵称
  agent;
  //代理id
  id;
  type_time

  @action
  setAttr({agent,search,type,proxy_type,id,type_time}) {

    this.resetAttr();
    this.search = search;
    this.type = type;
    if (proxy_type == undefined)
    {
      this.proxy_type = CustomerTypeSelect.getTypeId(CustomerTypeSelect.TYPE_AGENT_ALL);
    }
    else
    {
      this.proxy_type = proxy_type;
    }

    if (agent != undefined || agent != '')
    {
      this.agent = agent;
      this.id = MyAgentStore.findMyAgentId(agent);
    }

    this.type_time = type_time;

    this.is_init = true;
  }

  getAttr() {
    return {
      search: this.search,
      type: this.type,
      proxy_type: this.proxy_type,
      // id: this.id,
      type_time: this.type_time,
    }
  }

  setDefault(type) {
    // this.resetAttr();
    this.type_time = 6
    this.type = type;
    this.proxy_type = 2;
    this.is_init = true;
  }


  @action
  resetAttr() {
    this.search = undefined;
    this.type = undefined;
    this.proxy_type = undefined;
    this.id = undefined;
    this.type_time = 6;
    this.agent = undefined;
    this.is_init = undefined;
  }
}

let filter_store = new FilterStore();

class WalletItemStore {

  static Type_Recharge = '1';
  static Type_Cash = '2';
  static Type_Default = '1';

  constructor(pagination) {
    this.init(pagination);
  }

  @action
  init(pagination){
    this.pagination_store = pagination;
  }

  @observable
  item_map = new Map();

  @observable
  pagination_store;

  //今日充值或今天提现数据
  @observable
  new_money = 0;

  currentType = WalletItemStore.Type_Default;

  /**
   *  item数组列表
   */
  @computed
  get item_array() {
    let res = [];
    this.item_map.forEach((values, key) => {
      res.push(values);
    });
    return res;
  }

  @action
  reloadDatas(type = this.currentType,filter) {
    this.item_map.clear();
    this.new_money = 0;
    this.currentType = type;
    this.pagination_store.clear();
    if (filter == undefined)
    {
        filter_store.setDefault(type)
    }
    else
    {
      filter_store.setAttr(filter);
    }

    this.searchByFilter({
      desc: '1',
      order: "pay_time"
    });
  }

  /**
   * 根据条件搜索 item
   * @param {*} page_opts
   */
  async searchByFilter(page_opts){
    let page_option = {
      page: this.pagination_store.page_cur,
      page_size: this.pagination_store.page_size,
      ...filter_store.getAttr(),
      ...page_opts
    }
    let res = await this._getItemArray(page_option);
    return res;
  }

  /**
   * 获取 item列表
   */
  async _getItemArray(page_option = {}) {

    let url = fetchUrl.admin.proxy_pay_list;
    let res = await service.fetchData({
      path: url,
      params: {
        type:this.currentType,
        ...page_option
      }
    });
    service.responseHandle({
      res: res,
      success_handle: (res) => {
        runInAction(() => {
          // console.log(res);
          this.item_map.clear();
          res.data.data.forEach((item, index) => {
            this.item_map.set(item.id, new Item(item));
          });
          this.pagination_store.setAttr(res.data.page);
          this.new_money = res.data.summoney;
        })
      },
      fail_handle: (res) => {
        message.error(res.error.error_data,3);
        this.pagination_store.clear();
        filter_store.resetAttr();
        this.item_map.clear();
      }
    });
    return res;
  }
}

let pagination_store = new PaginationStore();
let item_store = new WalletItemStore(pagination_store);

export {
  pagination_store,
  filter_store,
  WalletItemStore
}
export default item_store;



// WEBPACK FOOTER //
// ./src/Store/Statistic/WalletHistory/WalletHistoryStore.js